import { Fragment } from 'react';
import HeroSection from './components/HeroSection';
import MembershipBenefits from './components/MembershipBenefits';
import Categories from './components/Categories';
import VerifiedMemberPoints from './components/VerifiedMemberPoints';
import EthicsCode from './components/EthicCodes';
import CommitCodeEthic from './components/CommitCodeEthic';
import CertificateSample from './components/CertificateSample';
import NeedHelp from './components/NeedHelp';


const nominationProcess = [
    {
        name: "Call for Nominations",
        title: "Call for Nominations",
        path: "/assets/services/1/verified-member/clipboard-check.png",
        description: "Announced annually via FWPI official channels."
    },
    {
        name: "Screening & Evaluation",
        title: "Screening & Evaluation",
        path: "/assets/services/1/verified-member/website.png",
        description: "Independent jury panel assesses based on predefined criteria."
    },
    {
        name: "Final Shortlist",
        title: "Final Shortlist",
        path: "/assets/services/1/verified-member/showcase.png",
        description: "Top candidates selected for recognition."
    },
    {
        name: "Award Ceremony",
        title: "Award Ceremony",
        path: "/assets/services/1/verified-member/navigation.png",
        description: "Winners announced at the FWPI Annual Gala or Conference."
    },
    {
        name: "Submit Nomination Form",
        title: "Submit Nomination Form",
        path: "/assets/services/1/verified-member/leads.png",
        description: "Complete the form and provide relevant supporting documents, photos, or videos."
    }
];

const members = [
    {
        alt: 'Mortarboard',
        icon: "/assets/services/4/benefits/Mortarboard.png",
        title: "National Recognition",
        description: "Gain industry-wide acknowledgment for your contribution and achievements."
    },
    {

        alt: 'Voucher',
        icon: "/assets/services/4/benefits/Voucher.png",
        title: "Enhanced Credibility",
        description: "Strengthen your reputation as a trusted professional or organization in the wellness sector."
    },
    {

        alt: 'Stairs-Up',
        icon: "/assets/services/4/benefits/Stairs-Up.png",
        title: "Career & Business Growth",
        description: "Open doors to new opportunities, partnerships, and collaborations."
    },
    {

        alt: 'Collaborator',
        icon: "/assets/services/4/benefits/Collaborator.png",
        title: "Motivation & Inspiration",
        description: "inspire peers and set new benchmarks in professionalism and service quality."
    },
    {

        alt: 'Brainstorm-Skill',
        icon: "/assets/services/4/benefits/Brainstorm-Skill.png",
        title: "Networking Opportunities",
        description: "Connect with industry leaders, influencers, and stakeholders at the FWPI Annual Gala."
    }
];

const individualAwards = [
    'Fitness Professional of the Year',
    'Wellness Professional of the year',
    'Personal Trainer of the Year',
    'Dance Instructor of the Year',
    'Yoga Instructor of the Year',
    'Nutrition Advisor of the Year',
    'Lifetime Achievement Award',
    'Exercise Professional of the Year',
    'Physique Transformation Specialist of the Year',
    'Fitness Entrepreneur of the Year'
];

const instituteAwards = [
    'Best Fitness Academy',
    'Best Gym / Studio',
    'Most Innovative Wellness Startup',
    'Upcoming Fitness Academy',
];
const communityAwards = [
    'Social Impact in Fitness & Wellness',
    'Public Health & Awareness Initiative',
    'Women in Wellness Leadership Award',
];

const ethicsPrinciples = [
    {
        id: 1,
        title: "Integrity",
        content:
            "Members must act with honesty, fairness, and transparency in all professional activities. They should maintain up-to-date knowledge, demonstrate reliability, and make decisions based on evidence and the best interests of clients, avoiding conflicts of interest at all times.",
    },
    {
        id: 2,
        title: "Ethical Practice",
        content:
            "Members must uphold the highest ethical standards by ensuring that all professional interactions are honest, respectful, and free from deception. They should provide accurate information about qualifications, services, and fees, and ensure that advertising and promotion are truthful and responsible.",
    },
    {
        id: 3,
        title: "Professional Standards",
        content:
            "Follow fair business practices and respect client confidentiality.",
    },
    {
        id: 4,
        title: "Respect & Inclusion",
        content:
            "Maintain high-quality service and continuous professional development.",
    },
    {
        id: 5,
        title: "Accountability",
        content:
            "Members are responsible for their actions and the outcomes of their professional decisions. They must protect client privacy, maintain secure records, and be transparent about errors or ethical concerns, taking corrective measures promptly and appropriately.",
    },
];

const Awards = () => {
    return (
        <Fragment>
            <section className="w-full bg-gradient-radial pt-32 pb-12 lg:py-40">
                <div className="container mx-auto px-4 lg:px-15 flex flex-col lg:flex-row items-center gap-10">
                    <div className="w-full lg:w-1/2 flex flex-col items-center lg:items-start text-center lg:text-left gap-8">
                        <p className="text-sm sm:text-base lg:text-xl font-urbanist text-stone-300">
                            Honouring the Change-Makers of India’s <br />Health & Wellness Industry
                        </p>
                        <h1 className="text-3xl sm:text-5xl lg:text-5xl font-bold font-urbanist text-white capitalize text-left leading-tight">
                            FWPI Awards – Fitness<br />& Wellness Excellence
                        </h1>
                        <p className="text-sm sm:text-base lg:text-xl font-urbanist font-semibold text-stone-300">
                            The Fitness & Wellness Professionals of India (FWPI) Awards & Recognition Program celebrates individuals, teams, and organisations that showcase exceptional dedication, innovation, and  leadership in advancing the fitness, nutrition, and wellness industry across the nation.
                        </p>
                    </div>
                    <div className="w-full lg:w-1/2 flex flex-col items-center lg:items-start">
                        <img className="w-full h-auto object-cover rounded-tl-2xl rounded-[5rem] md:rounded-[8rem] border-2 border-white" src="/assets/services/4/hero.jpg" alt="service-hero-section" />
                    </div>
                </div>
            </section>
            <MembershipBenefits
                title={'Why Nominate?'}
                benefits={members}
                buttonName="Join Now"
                pathname='/contact-us'
            />
            <Categories
                mainContainerClass="lg:py-5 py-5"
                title={'Award Categories Area Wise'}
                description={'Individual Awards'}
                tags={individualAwards}
            />
            <Categories
                mainContainerClass="lg:py-5 py-5"
                description={'Institutional Awards'}
                tags={instituteAwards}
            />
            <Categories
                mainContainerClass="lg:py-5 py-5"
                description={'Community & Impact Awards'}
                tags={communityAwards}
            />
            <VerifiedMemberPoints
                title='Nomination & Selection Process'
                items={nominationProcess}
            />
            <EthicsCode
                title={'Code of Ethics for FWPI Award Nominees'}
                description={'All nominees must adhere to the FWPI Code of Ethics, which includes'}
                items={ethicsPrinciples}
            />
            <CommitCodeEthic
                title={'Commit to Code of Ethics'}
                description={'All Awards Nominee must agree to follow the FWPI Code of Ethics, promoting professionalism, authenticity, responsibility, and recognition.'}
                buttonName={'Apply Now'}
                pathname='/contact-us'
            />
            <CertificateSample
                imageClass={'rounded-lg'}
                imageContainerClass="lg:h-[22rem] rounded-lg"
                imagePath="/assets/services/4/certificate.png"
            />
            <NeedHelp />
        </Fragment>
    );
}

export { Awards };
